<template>
  <a :href="data.url" class="episode-item" :target="`${data.external_url?'_blank':''}`" rel="noopener noreferrer">
    <div
        :id="data.id"
        class="episode-item__inner"
    >
      <AppImageFocal v-if="data.image" :data="data.image" :renditions="renditions"/>
      <div class="episode-item__wrapper">
        <AppIconLoader v-if="data.external_url" name="external" aria-hidden="true" variant="medium"/>
        <AppLogoNpoStart v-if="data.external_url"/>
      </div>
      <div class="episode-item__content">
        <AppTagText :title="data.program_label" :no-background="true"/>
        <h3 class="episode-item__title">
          {{ data.episode_label }}
        </h3>
      </div>
    </div>
  </a>
</template>

<script setup lang="ts">
import {TEpisodeItem} from '~/types/block-types'
import {TImageRendition} from '~/types/other-types'

const renditions: TImageRendition[] = [
  {width: 326, height: 173, breakpoint: 'xs'}
]

const props = defineProps<{
  data: TEpisodeItem
}>()
</script>

<style scoped lang="postcss">
.episode-item {
  &__inner {
    position: relative;
    width: 326px;
    overflow: clip;
    border-radius: 20px;
    border-width: 3px;
    border-color: var(--color-blue-aqua);
    transition-duration: 300ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    @mixin app-box-shadow-with-hover;
  }

  &__wrapper {
    position: absolute;
    right: 0px;
    top: 0px;
    margin-right: 1.25rem;
    margin-top: 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  &__content {
    padding: 1rem;
    transition-duration: 300ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }

  &__title {
    padding-top: 0.5rem;
    font-family: GraphikWide, sans-serif;
    font-size: 20px;
    line-height: 1.1;
    font-weight: 700;
    color: #fff;
  }

  &:hover {
    .tag-text {
      border-color: var(--color-blue-prussian);
      color: inherit;
    }

    .episode-item__content {
      background-color: var(--color-blue-aqua);
      color: var(--color-blue-prussian);
    }
  }
}
</style>
